<!--<ion-accordion-group class="groups"-->
<!--                     [ngClass]="{'ion-margin-bottom' : withMarginBtn}"-->
<!--                     [value]="'first' "-->
<!--                     *transloco="let t; read: 'profileBarComp'">-->

<!--    <ion-accordion value="{{ isSchedule ?'first':  group.id }}" class=" groups-accor-{{ class }}" [ngClass]="{'is-schedule': isSchedule}">-->
<!--        <ion-item slot="header" class="{{ class }}" color="yellow">-->
<!--            <ion-label>-->
<!--                <div class="title"> {{ title }}</div>-->
<!--                <div class="info"> {{ groupTitle }}-->
<!--                </div>-->
<!--            </ion-label>-->
<!--        </ion-item>-->
<!--        <div class="content-accordion list-info" slot="content">-->
<!--            <ion-list>-->
<!--                <ion-item>-->
<!--                    <ion-label class="ion-no-margin">-->
<!--                        <div class="info">-->
<!--                            <div class="title">{{ t('level') }}</div>-->
<!--                            <div class="sub-title ion-align-items-end">-->
<!--                                <img src="/assets/images/icons/levels.svg" alt="levels">-->
<!--                                {{ group.englishLevel }}-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </ion-label>-->
<!--                </ion-item>-->
<!--                <ion-item>-->
<!--                    <ion-label>-->
<!--                        <div class="info">-->
<!--                            <div class="title">{{ t('studyMaterial') }}</div>-->
<!--                            <div class="sub-title ion-align-items-end">-->
<!--                                <img src="/assets/images/icons/books.svg" alt="books">-->
<!--                                {{ group.educationMaterialTitle }}-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </ion-label>-->
<!--                </ion-item>-->
<!--                <ion-item>-->
<!--                    <ion-label>-->
<!--                        <div class="info">-->
<!--                            <div class="title">{{ t('schedule') }}</div>-->
<!--                            <div class="sub-title ion-align-items-end">-->
<!--                                <img src="/assets/images/icons/schedule.svg" alt="calendar">-->
<!--                                {{ group.schedule }}-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </ion-label>-->
<!--                </ion-item>-->
<!--                <ion-item *ngIf="group.holidays">-->
<!--                    <ion-label>-->
<!--                        <div class="info">-->
<!--                            <div class="title">{{ t('holidays') }}</div>-->
<!--                            <div class="sub-title ion-align-items-end">-->
<!--                                <img src="/assets/images/icons/holidays.svg" alt="holidays">-->
<!--                                {{ group.holidays }}-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </ion-label>-->
<!--                </ion-item>-->
<!--                <ion-item>-->
<!--                    <ion-label>-->
<!--                        <div class="info">-->
<!--                            <div class="title">{{ t('teacher') }}</div>-->
<!--                            <div class="sub-title ion-align-items-end">-->
<!--                                <img src="/assets/images/icons/teacher.svg" alt="teacher">-->
<!--                                {{ group.teacherName }}-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </ion-label>-->
<!--                </ion-item>-->

<!--                <ion-item>-->
<!--                    <ion-label>-->
<!--                        <div class="info">-->
<!--                            <div class="title">{{ t('address') }}</div>-->
<!--                            <div class="sub-title  ion-align-items-end">-->
<!--                                <img src="/assets/images/icons/location.svg" alt="location">-->
<!--                                {{ group.address }}-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </ion-label>-->
<!--                </ion-item>-->
<!--            </ion-list>-->
<!--        </div>-->
<!--    </ion-accordion>-->
<!--</ion-accordion-group>-->




<!--<ion-accordion-group class="groups"-->
<!--                     [ngClass]="{'ion-margin-bottom' : withMarginBtn}"-->
<!--                     *transloco="let t; read: 'profileBarComp'">-->

<div class="groups" [ngClass]="{'ion-margin-bottom' : withMarginBtn}" *transloco="let t; read: 'profileBarComp'">
    <div class=" groups-accor-{{ class }}" [ngClass]="{'is-schedule': isSchedule}"
         (click)="showMoreInfo = !showMoreInfo">
        <div class="{{ class }}">
            <div class="top-wrapper">
                <div class="title"> {{ title }} </div>

                <div class="btn-wrapper">
<!--                    <div class="info"> {{ groupTitle|transloco }}</div>-->
                    <div class="info"> {{ groupTitle }}</div>

                    <div class="arrow" [ngClass]="{'up': showMoreInfo }"></div>


                </div>


            </div>
        </div>
        <div class="list-info"
             [ngClass]="{'show':isSchedule || (this.activeTime == group.time && showMoreInfo)  || showMoreInfo}">
            <ion-list>
                <ion-item>
                    <ion-label class="ion-no-margin">
                        <div class="info">
                            <div class="title">{{ t('level') }}</div>
                            <div class="sub-title ion-align-items-end">
                                <img src="/assets/images/icons/levels.svg" alt="levels">
                                {{ group.englishLevel }}
                            </div>
                        </div>
                    </ion-label>
                </ion-item>
                <ion-item>
                    <ion-label>
                        <div class="info">
                            <div class="title">{{ t('studyMaterial') }}</div>
                            <div class="sub-title ion-align-items-end">
                                <img src="/assets/images/icons/books.svg" alt="books">
                                {{ group.educationMaterialTitle }}
                            </div>
                        </div>
                    </ion-label>
                </ion-item>
                <ion-item>
                    <ion-label>
                        <div class="info">
                            <div class="title">{{ t('schedule') }}</div>
                            <div class="sub-title ion-align-items-end">
                                <img src="/assets/images/icons/schedule.svg" alt="calendar">
                                {{ group.schedule }}
                            </div>
                        </div>
                    </ion-label>
                </ion-item>
                <ion-item *ngIf="group.holidays">
                    <ion-label>
                        <div class="info">
                            <div class="title">{{ t('holidays') }}</div>
                            <div class="sub-title ion-align-items-end">
                                <img src="/assets/images/icons/holidays.svg" alt="holidays">
                                {{ group.holidays }}
                            </div>
                        </div>
                    </ion-label>
                </ion-item>
                <ion-item>
                    <ion-label>
                        <div class="info">
                            <div class="title">{{ t('teacher') }}</div>
                            <div class="sub-title ion-align-items-end">
                                <img src="/assets/images/icons/teacher.svg" alt="teacher">
                                {{ group.teacherName }}
                            </div>
                        </div>
                    </ion-label>
                </ion-item>

                <ion-item>
                    <ion-label>
                        <div class="info">
                            <div class="title">{{ t('address') }}</div>
                            <div class="sub-title  ion-align-items-end">
                                <img src="/assets/images/icons/location.svg" alt="location">
                                {{ group.address }}
                            </div>
                        </div>
                    </ion-label>
                </ion-item>
            </ion-list>
        </div>
    </div>

</div>


<!--</ion-accordion-group>-->






